import axiosInstance from "./interceptor";

// axiosInstanceeService.js

export const get = async (url, config = {}, onLoading) => {
  try {
    // onLoading(true);
    const response = await axiosInstance.get(url, config);
    onLoading(false);
    return response;
  } catch (error) {
    if (error?.response?.data?.message === "jwt expired") {
      handleLogout();
    }
    onLoading(false);
  }
};

export const post = async (url, data, config = {}, onLoading) => {
  try {
    onLoading(true);
    const response = await axiosInstance.post(url, data, config);
    onLoading(false);
    return response;
  } catch (error) {
    onLoading(false);
  }
};

export const put = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.put(url, data, config);
    return response.data;
  } catch (error) {
    console.log("error received--------->", error);
  }
};

export const patch = async (url, data, config = {}, onLoading) => {
  try {
    onLoading(true);
    const response = await axiosInstance.patch(url, data, config);
    onLoading(false);
    return response;
  } catch (error) {
    onLoading(false);
  }
};

export const remove = async (url, config = {}, onLoading) => {
  try {
    onLoading(true);
    const response = await axiosInstance.delete(url, config);
    onLoading(false);
    return response;
  } catch (error) {
    onLoading(false);
  }
};

export const handleLogout = () => {
  sessionStorage.removeItem("authToken");
  sessionStorage.removeItem("userId");
  sessionStorage.removeItem("userRole");
  sessionStorage.removeItem("userConfigurationStep");
  window.location.href = "/signin";
};

// fetch paginated data
export const fetchPaginatedData = async (url, page, pageSize = 10) => {
  const response = await get(`${url}?page=${page}&pageSize=${pageSize}`);
  return response;
};

// upload file
export const uploadFile = async (url, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axiosInstance.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const buildQueryParams = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return queryString ? `?${queryString}` : "";
};

export const fetchFilteredData = async (url, filters) => {
  const queryParams = buildQueryParams(filters);
  return get(`${url}${queryParams}`);
};
